import React from "react";
import PropTypes from "prop-types";
import StoreZoneSceneLuxBandTable from "../StoreZoneSceneLuxBandTable";

const StoreZoneSceneLevelsFormContainer = props => (
  <div>
    <StoreZoneSceneLuxBandTable
      {...props}
      zoneScene={props.zoneScene}
      errors={props.errors}
      fields={props.fields}
      scene={props.zoneScene.scene.name}
      handleInputChange={props.handleInputChange}
    />
  </div>
);

StoreZoneSceneLevelsFormContainer.propTypes = {
  zoneScene: PropTypes.shape({
    scene: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      luxBandsAreEnabled: PropTypes.bool
    }),
    value: PropTypes.shape({
      rampLevelSeconds: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
      level: PropTypes.shape({
        valuePercentage: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ])
      })
    }),
    luxBands: PropTypes.arrayOf(
      PropTypes.shape({
        luxLevelGreaterThan: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ]),
        rampLevelSeconds: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ]),
        level: PropTypes.shape({
          valuePercentage: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
          ])
        })
      })
    )
  }).isRequired,

  fields: PropTypes.shape({
    valuePercentage: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    }),
    rampLevelSeconds: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    }),
    luxLevelGreaterThan: PropTypes.shape({
      name: PropTypes.string,
      rules: PropTypes.array
    })
  }).isRequired,
  errors: PropTypes.shape({}).isRequired,
  scene: PropTypes.string.isRequired,
  handleInputChange: PropTypes.func.isRequired
};

export default StoreZoneSceneLevelsFormContainer;
